import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export function renderAccountWithTooltip(accountName, children) {
  if (!accountName) return children;
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-${accountName}`}>{accountName}</Tooltip>}
      delay={{ show: 100, hide: 0 }}
    >
      <span style={{ cursor: 'pointer' }}>{children}</span>
    </OverlayTrigger>
  );
}
